import script from "./ExpandableSearchComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./ExpandableSearchComponent.vue?vue&type=script&setup=true&lang=js"

import "./ExpandableSearchComponent.vue?vue&type=style&index=0&id=33a3d5bf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33a3d5bf"]])

export default __exports__